export class DialogConfirmationConfig {
  constructor(jsonData?: Partial<DialogConfirmationConfig>) {
    if (jsonData) {
      Object.assign(this, jsonData);
    }
  }
  question: string;
  name: string;
  cancel: string;
  action: string;
}
